import React, { useCallback } from 'react'
import { AdvancedMarker, useAdvancedMarkerRef } from '@vis.gl/react-google-maps'

const MapClusterMarker = ({ position, size, sizeAsText, onClick, clusterId, theme }) => {
  const [markerRef, marker] = useAdvancedMarkerRef()
  const handleClick = useCallback(
    () => onClick && onClick(marker, clusterId),
    [onClick, marker, clusterId]
  )

  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      zIndex={size}
      onClick={handleClick}
      className="marker cluster"
    >
      <div className="marker-cluster-content">
        {sizeAsText}
      </div>
    </AdvancedMarker>
  )
}

export default MapClusterMarker 